import { h } from 'preact'
import cn from 'classnames'
import { useContext, useState } from 'preact/hooks'
import { Svg } from 'components/ui'
import FieldsContext from '../../../fieldsContext'

import styles from './RatingStar.scss'

interface Props {
  ratings: number[]
  onClick: (value: number) => void
}

const starClickAnimationDuration = 500

const RatingStar = ({ ratings, onClick }: Props) => {
  const [currentValue, setCurrentValue] = useState(-1)
  const [hoverIndex, setHoverIndex] = useState<null | number>(null)
  const { isMultipleFields } = useContext(FieldsContext)!
  const [clicked, setClicked] = useState(false)

  const handleClick = (index: number) => () => {
    const isFirstClick = currentValue === -1
    setClicked(true)
    setCurrentValue(index)
    if (isMultipleFields) {
      onClick?.(index + 1)
      return
    }
    if (!isFirstClick) {
      onClick?.(index + 1)
    }
    setTimeout(() => {
      isFirstClick && onClick?.(index + 1)
      setClicked(false)
    }, starClickAnimationDuration)
  }

  return (
    <div
      className={cn(styles.stars, {
        'pointer-events-none': !isMultipleFields && clicked,
      })}
    >
      {ratings.map((x, i) => {
        const isHover = typeof hoverIndex === 'number' && hoverIndex >= i
        const isSelected = currentValue >= i
        const showClickedAnimation = clicked && currentValue >= i
        return (
          <div
            key={i + 'x'}
            className={styles.starWrap}
            onMouseEnter={() => setHoverIndex(i)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <div
              className={cn(
                styles.starBox,
                isHover && styles.hover,
                isSelected && styles.isSelected,
                showClickedAnimation && 'pulse'
              )}
              onClick={handleClick(i)}
            >
              <Svg.FeedbackStar className={cn(styles.starSvg)} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default RatingStar
